import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=561886ce"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports